import { Fragment, useMemo } from "react"
import { Link, Typography, type TypographyProps } from "@mui/material"

const URL_REGEX = /https?:\/\/[^\s<]+[^\s<.,;:!?)\]'"]/gi

type TextWithLinksProps = {
  text: string
  variant?: TypographyProps["variant"]
  sx?: TypographyProps["sx"]
}

export const TextWithLinks = ({ text, variant = "body1", sx }: TextWithLinksProps) => {
  const parts = useMemo(() => {
    const result: Array<{ type: "text" | "url"; value: string }> = []
    let lastIndex = 0
    const re = new RegExp(URL_REGEX.source, URL_REGEX.flags)
    let match: RegExpExecArray | null

    while ((match = re.exec(text)) !== null) {
      if (match.index > lastIndex) {
        result.push({ type: "text", value: text.slice(lastIndex, match.index) })
      }
      result.push({ type: "url", value: match[0] })
      lastIndex = match.index + match[0].length
    }

    if (lastIndex < text.length) {
      result.push({ type: "text", value: text.slice(lastIndex) })
    }

    return result
  }, [text])

  return (
    <Typography variant={variant} sx={{ whiteSpace: "pre-wrap", ...sx }}>
      {parts.map((part, index) =>
        part.type === "url" ? (
          <Link
            key={index}
            href={part.value}
            target="_blank"
            rel="noopener noreferrer"
          >
            {part.value}
          </Link>
        ) : (
          <Fragment key={index}>{part.value}</Fragment>
        )
      )}
    </Typography>
  )
}
